/* eslint-disable react/prop-types */
import { OverlayTrigger } from "react-bootstrap";
import GlobalTableSearch from "components/organisms/DataTable/components/GlobalTableSearch";

import DataTable from "components/organisms/DataTable/DataTable";
import LocationFilter from "components/molecules/LocationFilter/LocationFilter";
import { ReactComponent as ExportIcon } from "assets/images/icons/TopNavIcons/ExportIcon.svg";
import { useGetParcelProviderList } from "api/queries/user/useGetParcelProviderList";
import useCommonProviderListing from "./hooks/useCommonProviderListing";

// import component

const ParcelProviders = function () {
  const { instance, loading, totalData, popover, setLocationReferenceNumber } = useCommonProviderListing({
    useQueryHook: useGetParcelProviderList,
  });

  return (
    <DataTable
      tableInstance={instance}
      withoutBody
      totalData={totalData}
      isLoading={loading}
      draggable={false}
      headerLeft={
        <div className="d-md-flex justify-content-between flex-md-row flex-column w-100">
          <div className="mt-2 w-30-px">
            <GlobalTableSearch
              currentFilters={instance.state.globalFilter}
              setFilters={instance.setGlobalFilter}
              filterKey="query"
              eventContext="Provider"
            />
          </div>

          <div className="d-flex mt-3">
            <div className="cursor-pointer">
              <OverlayTrigger trigger="click" placement="bottom-end" overlay={popover} rootClose>
                <ExportIcon />
              </OverlayTrigger>
            </div>

            <div className="ml-3" style={{ width: "192px" }}>
              <LocationFilter
                disableAll
                onChange={(e) => {
                  setLocationReferenceNumber(e);
                }}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ParcelProviders;
